<template>
  <div>
    <cart-list/>
  </div>
</template>

<script>
import cartList from "../../../components/shop/cart/cartList";

export default {
  name: "cart",
  components: {cartList}
}
</script>

<style scoped>

</style>